module.exports = __webpack_public_path__ + "img/tuurro.s10.b.4289e848.png";